import React, { useState, useEffect } from "react";
import useApiCallHooks from "../../hooks/useApiCallHooks";
import { apiRoutes } from "../../routes/api/apiRoutes";
import { FaRegUser } from "react-icons/fa";
import { MdLockOutline } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { uiRoutes } from "../../routes/ui/uiRoutes";
import OverlayLoader from "../../components/Common/OverlayLoader";
const LoginPage = () => {
  const [responce, loading, error, callAPI, statusCode] = useApiCallHooks();
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    const savedEmail = localStorage.getItem("rememberedEmail");
    if (savedEmail) {
      setData((prev) => ({ ...prev, email: savedEmail }));
      setRememberMe(true);
    }
  }, []);
  const handelSubmit = (e) => {
    e.preventDefault();
    if (rememberMe) {
      localStorage.setItem("rememberedEmail", data.email);
    } else {
      localStorage.removeItem("rememberedEmail");
    }
    callAPI("post", apiRoutes.auth.login, data);
  };
  useEffect(() => {
    if (responce && responce?.data?.token) {
      localStorage.setItem("udata", btoa(JSON.stringify(responce.data)));
      window.location.href = "/home";
      // return navigate(uiRoutes.home);
    }
  }, [responce]);
  return (
    <div className="sh-login position-relative">
      <OverlayLoader show={loading} />
      <img
        src="/assets/img/others/h8_about_img_shape.svg"
        alt="shape"
        className="alltuchtopdown"
      />
      <img
        src="/assets/img/others/h8_about_img_shape.svg"
        alt="shape"
        className="alltuchtoptop"
      />
      <div className="row align-items-center ">
        <div className="col-md-12 col-lg-8 form-swiper-col">
          <div className="form-swiper">
            <Swiper
              navigation={true}
              loop={true}
              modules={[Navigation]}
              className="myLoginSwiper"
            >
              <SwiperSlide className="swiper-img">
                <img
                  src={"images/shubham/school-login-img.jpg"}
                  alt=""
                  className="swiper-slide-img"
                />
              </SwiperSlide>
              <SwiperSlide className="swiper-img">
                <img
                  src={"images/shubham/collage-login-img.jpg"}
                  alt=""
                  className="swiper-slide-img"
                />
              </SwiperSlide>
              <SwiperSlide className="swiper-img">
                <img
                  src={"images/shubham/school-login-img.jpg"}
                  alt=""
                  className="swiper-slide-img"
                />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
        <div className="col-md-12 col-lg-4">
          <div className="sh-login-icon-div ">
            <img src={"/images/sys-white-logo.png"} alt="" />
            <h6 className="login-heading">Login</h6>
            <h6 className="login-sub-heading">Sign in to continue</h6>
          </div>
          <form onSubmit={handelSubmit} className="sh-form p-3 p-md-4">
            <div className="input-group mb-4">
              <input
                type="text"
                className="form-control"
                placeholder="Enter Email"
                onChange={(e) => setData({ ...data, email: e.target.value })}
                value={data.email}
              />
              <span className="input-group-text">
                <FaRegUser />
              </span>
              
               
             
               
            </div>
              <span className="val-message text-white">
                  {error?.message === "ValidationError" && error?.data?.email}
                </span>
            <div className="input-group mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Password"
                onChange={(e) => setData({ ...data, password: e.target.value })}
                value={data.password}
              />
              <span className="input-group-text">
                <MdLockOutline />
              </span>
            </div>
             <span className="val-message text-white">
                  {error?.message === "ValidationError" && error?.data?.password}
                </span>
            <div className="sh-remember-div gap-2 mb-3">
              <div className="form-check">
                <input
                  className="form-check-input mt-2"
                  type="checkbox"
                  id="sh-rememberme"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                />
                <label className="form-label text-white" for="sh-rememberme">
                  Remember Me
                </label>
              </div>
              <Link to={"/forgot-password"} className="fw-semibold text-white">
                Forgot Password
              </Link>
            </div>
            <div className="text-center">
              <button
                type="submit"
                className="btn rounded bg-white text-dark m-0 mt-4 w-50"
              >
                Login
              </button>
            </div>
          </form>
          <div className="shape"></div>
          <div className="shape">
            <img
              src="/assets/img/others/h8_about_img_shape.svg"
              alt="shape"
              className="alltuchtoptop"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default LoginPage;